import { LoanHistory } from "@/modules/loan/components";
import { PageHeader } from "@/shared/components";

export const LoanHistoryPage = () => {
  return (
    <div className="full-width page-container">
      <PageHeader/>
      <LoanHistory/>
    </div>
  );
};
